import { definitions, } from "./tokens";
import type { TokenDefinition, ValidChainId } from "./types";

export declare type GetChainedTokensOptions = {
	includeETH?: boolean;

	/** include ONLY tokens by providing an array of their label or symbol */
	include?: string[];

	/** exclude INCLUDED tokens by providing an array of their label or symbol */
	exclude?: string[];

	/** tokens must have the stakable property true */
	stakable?: boolean;

	/** tokens must have the swapable property true */
	swapable?: boolean;

	/** tokens must have the parity specified param */
	parity?: boolean;

	/** tokens must have the swapto property specified true/false */
	swapto?: boolean;

	/** tokens must have the inactive property specified true/false */
	inactive?: boolean;

	/** set true if you want disabled tokens - unlike inactive tokens, disabled tokens are not normally included by default. */
	disabled?: boolean;

}

/** get a token definition on a specified on an argued chain given the token symbol or label
 * @param {ValidChainId} chain the chain id
 * @param {string} name the chain symbol or label
 * @returns {TokenDefinition} an array of token definitions */
export const getChainedToken = ( chain: ValidChainId, name: string, ): TokenDefinition => {
	const definition = definitions.find(def => def.chainId === chain && ( name.toUpperCase() === def.symbol || name === def.label || name === def.name) );
	if( definition ) {
		return definition;
	}
	throw new Error(`@bracket/addressbook::getChainedToken failed gaining a definition for token "${name}" on chain ${chain}`);
}



/** get an array of tokens specified on an argued chain
 * @param {ValidChainId} chain the chain id
 * @returns {TokenDefinition[]} an array of token definitions */
export const getChainedTokens = ( chain: ValidChainId, options: GetChainedTokensOptions = {}): TokenDefinition[] => {

	const {
		includeETH,
		include,
		exclude,
		stakable,
		swapable,
		parity,
		swapto,
		inactive,
		disabled,
	} = options;

	const tokens = definitions.filter(def => def.chainId === chain);

	if(tokens.length) {
		let result = includeETH ? tokens : tokens.filter(tok => tok.symbol !== "ETH")
		result = include ? result.filter(incl => include.includes(incl.name) || include.includes(incl.symbol) || include.includes(incl.label)) : result;
		result = exclude ? result.filter(tok => !(exclude.includes(tok.name) || exclude.includes(tok.symbol) || exclude.includes(tok.label))) : result;
		result = stakable ? result.filter(tok => tok.stakable === true) : result;
		result = swapable ? result.filter(tok => tok.stakable === true) : result;
		result = typeof parity === "boolean" ? result.filter(tok => tok.parity === parity) : result;
		result = typeof swapto === "boolean" ? result.filter(tok => tok.swapto === swapto) : result;
		result = typeof inactive === "boolean" ? result.filter(tok => tok.inactive === inactive) : result;
		result = typeof disabled === "boolean" ? result.filter(tok => tok.disabled === disabled) : result.filter(tok => tok.disabled !== true);
		return result;
	}
	throw new Error(`@bracket/addressbook::getChainedTokens failed gaining any tokens on chain ${chain}`);
}
